<i [class]="getIconClass()"></i>
